export default "__VITE_ASSET__BTTx1_lo__"